// @flow
import React from 'react';

import {
  ProductServices,
  type Props as ProductServicesProps,
} from 'Components/widgets/product-services/ProductServices.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';

type Props = {
  ...$Exact<ProductServicesProps>,
  id?: string,
};

export function ProductServicesLine({ id, ...props }: Props) {
  return (
    <SiteContainer id={id} className="Line mb-16 lg:mb-10">
      <ProductServices {...props} />
    </SiteContainer>
  );
}
